module.exports = __webpack_public_path__ + "0fb8716b0725b4979873e86a57e575ef.png";


//////////////////
// WEBPACK FOOTER
// ./srv/public/img/widgettypes/charts/c_line_stacked_bar_1day_show_thresholds_show_labels.png
// module id = 877
// module chunks = 7